<template>
  <div class="naics-picker">
    <div class="autocomplete-wrapper">
      <PickerInput
        ref="suggestInput"
        :picker-id="pickerId"
        :aria-describedby="pickerId + '-naics-hint ' + pickerId + '-naics-details'"
        :aria-activedescendant="descendantAsign(highlightedIndex, pickerId, '-option-')"
        :aria-controls="showSuggestions ? pickerId + '-suggestions' : null"
        aria-label="NAICS search"
        type="search"
      />

      <SuggestionsDropdown
        :picker-id="pickerId"
        :show-suggestions="showSuggestions"
        :suggestions="suggestions"
        :highlighted-index="highlightedIndex"
        :dropdown-style="dropdownStyle"
        dropdowntype="naics"
        @select-suggestion="selectSuggestion"
        @update-highlighted="highlightedIndex = $event"
      />

      <LoadingIndicator :loading="loading" />
    </div>

    <div
      v-show="inputShown"
      :id="pickerId + '-naics-hint'"
      class="hint"
    >
      Enter a keyword or 6-digit NAICS code for your industry.
      <a
        href="https://www.naics.com/search/"
        data-tooltip="true"
        title="Opens in a new window"
        target="_blank"
      >
        Search for NAICS Codes
        <span
          class="icon-general_link_external"
          aria-hidden="true"
        ></span>
      </a>
    </div>

    <!-- TODO: Ticket 42400 Remove hidden class once naics description has been added to JSON -->
    <div
      v-if="shownLabel || shownDescription"
      :id="pickerId + '-naics-details'"
      class="vue-simple-picker__description"
    >
      <span
        v-if="shownLabel"
        class="vue-simple-picker__short-label"
      >
        {{ chosen?.shortLabel || chosen?.label }}
      </span>
      <span
        v-if="shownDescription"
        class="vue-simple-picker__code"
      >
        {{ chosen?.code }}
      </span>
      <span
        v-if="shownDescription"
        class="vue-simple-picker__label-description"
      >
        {{ chosen?.description }}
      </span>
    </div>

    <input
      :id="inputId"
      :value="fieldValue"
      :name="inputName"
      type="hidden"
    />

    <p v-if="debug">
      <strong>Hidden Input:</strong> {{ inputName }}={{ fieldValue }}<br />
      <strong>Initial Value:</strong> {{ inputValue }}
    </p>
  </div>
</template>

<script>
import BasePicker from './onet_naics_shared';
import LoadingIndicator from './LoadingIndicator.vue';
import PickerInput from './PickerInput.vue';
import SuggestionsDropdown from './SuggestionsDropdown.vue';
import './vue_picker.css';

export default {
  name: 'NaicsPicker',

  components: {
    LoadingIndicator,
    PickerInput,
    SuggestionsDropdown,
  },

  extends: BasePicker,

  props: {
    valueMode: {
      validator(val) {
        return ['code', 'id'].includes(val);
      },
      default: 'code',
    },
  },

  methods: {
    apiUrl() {
      return '/lookup/industry_lookups.json';
    },

    async fetchSuggestions() {
      try {
        const results = await this.populateLookupData();

        this.suggestions = results.slice(0, 20); // Max 20
        this.showSuggestions = true;
        this.highlightedIndex = -1;
        this.takeLocation();
      } catch (_error) {
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },
  },
};
</script>
